import {createSlice, PayloadAction} from '@reduxjs/toolkit';

// import out Jobs state interface, and the Job interface
import {ApplicantsStateInterface} from './models';
import {ApplicantInterface} from '../../models';

// create an object that represents our initial Jobs state
const initialApplicantsState: ApplicantsStateInterface = {
  loading: false,
  applicants: [],
};

// create the JobsStoreSlice with createSlice:
export const ApplicantsStoreSlice = createSlice({
  name: 'ApplicatsStoreSlice',
  initialState: initialApplicantsState,
  reducers: {
    // reducers are functions that commit final mutations to the state
    // These will commit final mutation/changes to the state

    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    setApplicants: (state, action: PayloadAction<ApplicantInterface[]>) => {
      // update our state:
      // set our Jobs
      state.applicants = action.payload || [];
      // set loading to false so the loader will be hidden in the UI
      state.loading = false;
    },
  },
});
